export function Hero({children}) {

  return (
    <div className="viewport__container viewport__container__hero">
      <div className="hero__content">
      <div className="home__wrapper">
      <div className="home__cube"></div>
      <div className="home__shader"></div>
      <div className="home__content">
        <section className="home__intro">
          <div className="home__intro__container">
            <h1 className="home__intro__title">PNDR</h1>
          </div>
          <div className="home__highlight">
            <h2 className="home__highlight__title"></h2>
          </div>
          <div className="home__message">
            <h3 className="pndr__headline-3">
              We <span>design business</span><br/>
              led by human behaviors
            </h3>
          </div>
        </section>
      </div>
    </div>
    </div>
      {children}
    </div>
  );
}
